import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitSymptomService {
  temrVisitSymptom: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_visit_symptom/list/?';
  private AddRecord = webapi + 'temr_visit_symptom/create';
  private AddRecordList = webapi + 'temr_visit_symptom/createList';
  private EditRecord = webapi + 'temr_visit_symptom/update';
  private GetRecord = webapi + 'temr_visit_symptom/byid/';
  private DeleteRecord = webapi + 'temr_visit_symptom/delete/';
  private ListByVisitId = webapi + 'temr_visit_symptom/listbyvisitid/';
  private ListByTimelineId = webapi + 'temr_visit_symptom/listbytimelineid/';
  private GetAllRecordByTimelineList = webapi + 'temr_visit_symptom/getAllRecordByTimelineList';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    addListRecordService(model: any) {
        return this.http.post(this.AddRecordList, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByVisitIdRecordService(id: any) {
    return this.http.get(this.ListByVisitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByTimelineRecordService(id: any) {
    return this.http.get(this.ListByTimelineId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-symptom/temr-visit-symptom.service.ts